/**
 * Static fallback content for the Contact Us CMS page.
 * Includes:
 * - hero: Main heading and subtitle
 * - floating_icons: List of floating action buttons on screen
 * - management_emails: List of recipient emails for contact form submissions
 * - contact_details: General contact information
 */

export const contactUsFallbackContent = {
  hero: {
    title: "Connect With ASSET",
    subtitle: "We are here to support your engineering journey, answer questions, and build meaningful partnerships.",
    description: "Choose a category below to get in touch with our team or explore collaboration opportunities.",
  },
  floating_icons: {
    items: [
      {
        label: "WhatsApp Us",
        url: "https://wa.me/919894055835",
        iconKey: "floating_icon_whatsapp",
        enabled: "true",
      },
      {
        label: "Email Support",
        url: "https://mail.google.com/mail/?view=cm&fs=1&to=care@assetsociety.ngo",
        iconKey: "floating_icon_email",
        enabled: "true",
      },
    ],
  },
  management_emails: {
    recipients: [
      { email: "care@assetsociety.ngo" },
      { email: "anand@swifterz.co" },
      { email: "shankkerkumar@swifterz.co" },
    ],
  },
  contact_details: {
    phone: "+91 98940 55835",
    email: "care@assetsociety.ngo",
    address: "ASSET Society, Main Campus Road, Engineering Hub",
    hours: "Monday - Saturday: 9:00 AM - 6:00 PM IST",
  },
};

export default contactUsFallbackContent;
